// Helper function to categorize dates
export const getDateCategory = (date: Date): string => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const threeDaysAgo = new Date(today);
    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);

    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

    const oneMonthAgo = new Date(today);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    const threadDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    if (threadDate.getTime() === today.getTime()) {
        return 'Today';
    } else if (threadDate.getTime() === yesterday.getTime()) {
        return 'Yesterday';
    } else if (threadDate >= threeDaysAgo) {
        const dayDiff = Math.floor((today.getTime() - threadDate.getTime()) / (1000 * 60 * 60 * 24));
        return `${dayDiff} days ago`;
    } else if (threadDate >= oneWeekAgo) {
        return '1 week ago';
    } else if (threadDate >= oneMonthAgo) {
        const weekDiff = Math.floor((today.getTime() - threadDate.getTime()) / (1000 * 60 * 60 * 24 * 7));
        return `${weekDiff} weeks ago`;
    } else if (threadDate >= oneYearAgo) {
        const monthDiff = Math.floor((today.getTime() - threadDate.getTime()) / (1000 * 60 * 60 * 24 * 30));
        return `${monthDiff} months ago`;
    } else {
        return `${threadDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}`;
    }
};
